export const aboutNLTKData: string[] = [
  "Tokenization",
  "VADER Sentiment Intensity Analyzation",
  "Chunking",
];
